import { zetApi } from '@zet/network'

import { creditCardCrossSellingResponse } from './types'

export const getCreditCardCrossSelling = async (
  customerId: number,
  partnerId: number
) => {
  const { data } = await zetApi.get<creditCardCrossSellingResponse>(
    '/cross-selling/creditcard',
    {
      params: {
        ...(customerId ? { customerId } : {}),
        ...(partnerId ? { partnerId } : {}),
      },
    }
  )
  return data?.data
}
